var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"OAList"},[_c('d2-crud',{ref:"OAList",attrs:{"columns":_vm.columns,"data":_vm.tableData,"options":_vm.options,"loading":_vm.loading,"pagination":_vm.pagination},on:{"pagination-size-change":_vm.handleSizeChange,"pagination-current-change":_vm.handleCurrentChange,"row-click":_vm.rowClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0b75370","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OATable/OAList.vue
// module id = null
// module chunks = 